









































































































import Vue from 'vue';
import {ExtensionViewModel} from "@/models/ExtensionViewModel";
import {ExtensionDocumentViewModel} from "@/models/ExtensionDocumentViewModel";
import {UserViewModel} from "@/models/UserViewModel";
import ExtensionLogDetailsPanel from "@/components/extensions/ExtensionLogDetailsPanel.vue";
import ExtensionDetailsPanel from "@/components/extensions/ExtensionDetailsPanel.vue";
import ExtensionApplicantDetailsPanel from "@/components/extensions/ExtensionApplicantDetailsPanel.vue";
import BoxContainer from "@/components/BoxContainer.vue";
import ExtensionApprovalSubmittedPanel from "@/components/extensions/ExtensionApprovalSubmittedPanel.vue";
import ExtensionApprovalReadyForReview from "@/components/extensions/ExtensionApprovalReadyForReview.vue";
import ExtensionNotesPanel from "@/components/extensions/ExtensionNotesPanel.vue";
import ExtensionAssignmentPanel from "@/components/extensions/ExtensionAssignmentPanel.vue";
import ExtensionApprovalFinal from "@/components/extensions/ExtensionApprovalFinal.vue";
import ExtensionApprovalAssignToLwo from "@/components/extensions/ExtensionApprovalAssignToLwo.vue"
import ExtensionApprovalFinalLwo from "@/components/extensions/ExtensionApprovalFinalLwo.vue";

export default Vue.extend( {
  name: "ExtensionAdmin" ,
  components: {
    // ExtensionApprovalFinalLwo,
    // ExtensionApprovalAssignToLwo,
    ExtensionApprovalFinal,
    ExtensionAssignmentPanel,
    ExtensionNotesPanel,
    ExtensionApprovalReadyForReview,
    ExtensionApprovalSubmittedPanel,
    ExtensionApplicantDetailsPanel,
    ExtensionLogDetailsPanel,
    ExtensionDetailsPanel,
    BoxContainer
  },
  data(): {
    itemId: number;
    extension: ExtensionViewModel;
    documentList: ExtensionDocumentViewModel[];
    assignedToMessage: string;
  }{
    return {
      itemId: 0,
      extension: {} as ExtensionViewModel,
      documentList: [] as ExtensionDocumentViewModel[],
      assignedToMessage: "",
    }
  } ,
  computed: {
    apiURL() {
      return process.env.VUE_APP_API_URL
    },
    loggedInUser(): UserViewModel {
      return this.$store.state.loggedInUser;
    }
  } ,
  methods: {
    async loadData() {
      if (this.itemId > 0 ) {
        let result = await this.axios.get('/Extensions/GetOne' , {
          params: { id: this.itemId }
        });

        this.extension = result.data;

        // Handle the Currently Assigned To Message
        if ( this.extension.currentlyAssignedTo ) {
          this.assignedToMessage = "( currently assigned to " + this.extension.currentlyAssignedTo + " )";
        } else {
          this.assignedToMessage = "";
        }

        // Quick security check, need to redirect if is Admin user and this is not status Submitted, or if LWO ( limited user ) and status is not appropriate
        if ( ( this.loggedInUser.isExtensionsAdminUser && !this.loggedInUser.isExtensionsUser ) && this.extension.statusCode !== 'SBMT' ) {
          await this.$router.push( {name: "extension-details" , params: { id: this.itemId.toString() } } );
        }
      }
    },
  } ,
  mounted: async function() {
    await this.loadData();
  },
  beforeMount() {
    if ( this.$route.params.id ) {
      this.itemId = parseInt( this.$route.params.id );
    }
  },
  beforeCreate() {
    setTimeout( async () => {
      if ( this.$store.state.loggedInUser == null ) {
        //make one attempt to get the current user info
        try {
          let result = await this.axios.get('Users/GetUserFromToken');
          if ( result.status === 200 ) {
            await this.$store.dispatch('updateUser', result.data);
          }
        } catch ( err ) {
          if ( err.response.status === 400  ) {
            await this.$router.push('/Login');
          }
        }
      }
    } , 250 );
  },
} )

